import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import AddIcon from '@mui/icons-material/Add'
import { Link } from 'react-router-dom'
import { AppRoutes } from '../../routes/Routes'
import Fab from '@mui/material/Fab'
import Connections from '../../components/Connections'

const VernetzungenScreen = () => {
  return (
    <Box px={2} py={3}>
      <Typography variant="h4" pb={4}>
        Vernetzungen
      </Typography>
      <Box width={'100%'} display="flex" justifyContent="flex-end" pb={4}>
        <Link to={AppRoutes.KONTAKTANFRAGE}>
          <Fab variant="extended" color="primary">
            <AddIcon sx={{ pr: 1 }} />
            Kontaktanfrage starten
          </Fab>
        </Link>
      </Box>
      <Connections />
    </Box>
  )
}

export default VernetzungenScreen